function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">GovSim</h3>
            <p className="text-gray-300 text-sm">
              Experience the challenges of governing a nation in this comprehensive 
              turn-based political simulation game.
            </p>
          </div>
          
          <div>
            <h4 className="text-md font-semibold mb-4">Game Features</h4>
            <ul className="text-gray-300 text-sm space-y-2">
              <li>Economic Management</li>
              <li>Diplomatic Relations</li>
              <li>Crisis Management</li>
              <li>Technology Research</li>
              <li>Trade & Resources</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-md font-semibold mb-4">About</h4>
            <ul className="text-gray-300 text-sm space-y-2">
              <li>How to Play</li>
              <li>Game Guide</li>
              <li>Support</li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} GovSim. Built with Cloudflare.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer